import './App.css';
import { BrowserRouter, useLocation } from "react-router-dom";
import AppRouter from "./router";
import Header from "./components/Header";

function AppContent() {
  const location = useLocation();
  const hideHeaderRoutes = ["/login"];
  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideHeader && <Header />}
      <AppRouter />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
